<template>
  <v-autocomplete
    :value="value"
    @input="$emit('input', $event)"
    :items="items"
    :loading="loading"
    item-value="id_proveedor"
    item-text="nombre_completo"
    label="Proveedor"
    outlined
    dense
    clearable
    hide-details
    :filter="proveedorFilter"
    :disabled="disabled"
  >
    <!-- Selección -->
    <template v-slot:selection="{ item }">
      <div class="d-flex align-center" style="width: 100%">
        <div class="flex-grow-1">
          <div class="font-weight-medium">
            {{ item.nombre_completo }}
          </div>

          <div class="text-caption">
            {{ item.clave }}
            <span v-if="getIdFiscalLabel(item)">
              | {{ getIdFiscalLabel(item) }}: {{ getIdFiscalValue(item) }}
            </span>
          </div>

          <div class="text-caption" v-if="getExtraLine(item)">
            {{ getExtraLine(item) }}
          </div>
        </div>
      </div>
    </template>

    <!-- Lista -->
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>
          {{ item.nombre_completo }}
        </v-list-item-title>

        <v-list-item-subtitle>
          <v-chip x-small class="mr-1">
            {{ item.clave }}
          </v-chip>

          <span class="mr-2">
            {{ item.nombre_proveedor_tipo }} | {{ item.nombre_persona_tipo }}
          </span>

          <span v-if="getIdFiscalLabel(item)">
            | {{ getIdFiscalLabel(item) }}: {{ getIdFiscalValue(item) }}
          </span>
        </v-list-item-subtitle>

        <v-list-item-subtitle class="text-caption">
          {{ item.nombre_proveedor_actividad }}
          <span v-if="getExtraLine(item)"> | {{ getExtraLine(item) }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "ProveedorAutocomplete",
  props: {
    value: {
      type: [String, null],
      default: null
    },
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isInternacional(item) {
      return (item?.nombre_proveedor_tipo || "").toLowerCase() === "internacional";
    },

    // Label del identificador fiscal según tipo
    getIdFiscalLabel(item) {
      if (!item) return null;
      return this.isInternacional(item) ? "NIF/Tax ID" : "RFC";
    },

    // Valor del identificador fiscal según tipo
    getIdFiscalValue(item) {
      if (!item) return null;
      return this.isInternacional(item)
        ? (item.numero_fiscal || "—")
        : (item.rfc || "—");
    },

    // Línea extra útil según tipo
    getExtraLine(item) {
      if (!item) return null;

      if (this.isInternacional(item)) {
        // Internacional: país + ciudad/región
        const parts = [];
        if (item.nombre_pais) parts.push(item.nombre_pais);
        if (item.ciudad) parts.push(item.ciudad);
        if (item.region) parts.push(item.region);

        return parts.length ? parts.join(" · ") : null;
      }

      // Nacional: régimen fiscal (si existe)
      return item.nombre_regimen_fiscal ? `Régimen: ${item.nombre_regimen_fiscal}` : null;
    },
    
    // Normaliza para búsqueda (case-insensitive, sin acentos, trim)
    normalize(s) {
      if (s === null || s === undefined) return "";
      return String(s)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();
    },

    // Filter de Vuetify: (item, queryText, itemText) => boolean
    proveedorFilter(item, queryText) {
      const q = this.normalize(queryText);
      if (!q) return true;

      const haystack = [
        item?.clave,
        item?.nombre_completo,
        item?.rfc,
        item?.numero_fiscal
      ]
        .map(this.normalize)
        .filter(Boolean)
        .join(" | ");

      return haystack.includes(q);
    }
  }
};
</script>
